/**
 * Win/lose end cards — smash-cut, high-contrast, case-closed stamp aesthetic.
 * Owned by UI.
 */
import type { EventBus } from '../core/types'
import type { CaseLog } from './caseLog'
import {
  LOSE_HEADLINE_SUFFIX,
  LOSE_STAMP,
  LOSE_SUBTEXT,
  WIN_HEADLINE_SUFFIX,
  WIN_STAMP,
  WIN_SUBTEXT
} from './constants'
import { el } from './dom'

export const createEndCards = (
  root: HTMLElement,
  bus: EventBus,
  caseLog: CaseLog,
  onShown: () => void
): void => {
  let shown = false

  const show = (won: boolean, suspectId: string): void => {
    if (shown) return
    shown = true
    const suspectName = caseLog.suspectName(suspectId).toUpperCase()
    const card = el('div', `gum-end ${won ? 'gum-end-won' : 'gum-end-lost'}`)
    card.append(
      el('div', 'gum-stamp', won ? WIN_STAMP : LOSE_STAMP),
      el('h2', 'gum-end-headline', `${suspectName}${won ? WIN_HEADLINE_SUFFIX : LOSE_HEADLINE_SUFFIX}`),
      el('p', 'gum-end-sub', won ? WIN_SUBTEXT : LOSE_SUBTEXT),
      el('div', 'gum-grain')
    )
    root.append(card)
    onShown()
  }

  bus.on('game:won', ({ suspectId }) => show(true, suspectId))
  bus.on('game:lost', ({ suspectId }) => show(false, suspectId))
}
